import { INotification } from '../../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { NotificationType } from '../../../../../../../models/notification.models';

export const getBirthdayPointsNotifications = (
  notifications: INotification[],
): INotification[] => notifications
  .filter(({ notificationType }) => notificationType === NotificationType.BIRTHDAY_POINT);